import { Text } from 'platform-components';
import React from 'react';

import './section-page__header.scss';

interface OwnProps {
    description?: string | null;
    header: React.ReactNode;
}

interface Props extends OwnProps {}

export const SectionPageHeader = ({ description, header }: Props) => {
    return (
        <div className="section-page__header">
            <div className="section-page__details">{header}</div>
            {description && (
                <div className="section-page__promo">
                    <Text type={Text.TYPE.MARKDOWN}>{description}</Text>
                </div>
            )}
        </div>
    );
};

export default SectionPageHeader;
